var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimer = function SvgTimer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Timer",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-537.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timer",
    transform: "translate(537.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,2 C6.22385763,2 6,1.77614237 6,1.5 C6,1.25454011 6.17687516,1.05039163 6.41012437,1.00805567 L6.5,1 L9.5,1 C9.77614237,1 10,1.22385763 10,1.5 C10,1.74545989 9.82312484,1.94960837 9.58987563,1.99194433 L9.5,2 L8.5,2 L8.50090367,3.02061151 C11.5802387,3.27511705 14,5.85497576 14,9 C14,12.3137085 11.3137085,15 8,15 C4.6862915,15 2,12.3137085 2,9 C2,5.85463498 4.42028573,3.27455798 7.50009733,3.02052886 L7.5,2 L6.5,2 Z M7.50030016,4.02465783 C4.97349494,4.27538101 3,6.40722328 3,9 C3,11.7614237 5.23857625,14 8,14 C10.5927767,14 12.724619,12.0265051 12.9753422,9.49969984 L8,9.5 C7.72385763,9.5 7.5,9.27614237 7.5,9 L7.5,9 Z",
    id: "Icons/16/Timer"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "timer.6649979373fbc13c8df15783d775c2e4.svg";